import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import CssTransition from "./css-transition";
import { useNavigate } from "react-router-dom";
import ChangePassword from "../../page/ChangePassword";
import Avatar from "../Avatar";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT, CLEAR_SEARCH, RESET_REDUX_STATE, RESET_COLOR_PALETTES } from "../../redux/constants";

function DropdownProfile({ align }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const trigger = useRef(null);
  const dropdown = useRef(null);

  const [width, setWidth] = useState(window.innerWidth);

  const windowResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", windowResize);
  }, [window.innerWidth]);

  const [modalOpen, setModalOpen] = useState(false);

  const navigate = useNavigate();

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className="inline-flex justify-center items-center group"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        {/* <img
          className="w-8 h-8 rounded-full"
          src="/user-avatar-32.png"
          width="32"
          height="32"
          alt="User"
        /> */}
        <Avatar name={user?.name} />
        <div title={user?.name} className="flex items-center truncate">
          <span className="truncate ml-2 text-sm font-medium group-hover:text-slate-800 md:inline hidden">
            {/* {user?.name} */}
            {user?.name}
          </span>
        </div>
      </button>

      <CssTransition
        className={`origin-top-right z-10 absolute top-full w-52 bg-white border border-slate-200 py-1.5 rounded shadow-lg overflow-hidden mt-1 ${
          align === "right" ? "right-0" : "left-0"
        }`}
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          <div className="pt-0.5 pb-2 px-3 mb-1 border-b border-slate-200">
            <div className="font-medium text-slate-800">{`${user?.name}`}</div>
            <div className="text-xs text-slate-500 italic">{user?.type}</div>
            <div className="w-3/4 truncate">
              <p
                title={user?.company?.name}
                className="text-xs text-slate-500 italic font-medium truncate"
              >
                {user?.company?.name}
              </p>
            </div>
          </div>
          <ul>
            {user?.type === "super-admin" && (
              <li>
                <Link
                  className="font-medium text-sm text-[--bg-color-500] hover:text-[--bg-color-600] flex items-center py-1 px-3"
                  to="/myaccount"
                  onClick={() => {
                    setDropdownOpen(!dropdownOpen);
                    dispatch({ type: CLEAR_SEARCH });
                  }}
                >
                  Settings
                </Link>
              </li>
            )}
            {user?.type !== "collaborator" && user?.type !== "customer" && (
              <li>
                <div
                  className="font-medium text-sm text-[--bg-color-500] hover:text-[--bg-color-600] flex items-center py-1 px-3 cursor-pointer"
                  onClick={() => {
                    setModalOpen(!modalOpen);
                    setDropdownOpen(!dropdownOpen);
                  }}
                >
                  Change Password
                </div>
              </li>
            )}

            <li>
              <div
                className="font-medium text-sm text-[--bg-color-500] hover:text-[--bg-color-600] flex items-center py-1 px-3 cursor-pointer"
                onClick={() => {
                  dispatch({ type: LOGOUT });
                  dispatch({ type: CLEAR_SEARCH });
                  dispatch({ type: RESET_REDUX_STATE });
                  dispatch({ type: RESET_COLOR_PALETTES });
                  // ctx.logout();
                  localStorage.clear();
                  setDropdownOpen(!dropdownOpen);
                  navigate("/login");
                }}
              >
                Sign Out
              </div>
            </li>
          </ul>
        </div>
      </CssTransition>

      <ChangePassword setModalOpen={setModalOpen} modalOpen={modalOpen} />
    </div>
  );
}

export default DropdownProfile;
